export default __webpack_public_path__ + "static/media/loading.939afdb5.gif";